import { getUserAndEventTime } from './lib/index.js';
import { WEBHOOK_EVENT_TYPES } from '../webhook-event-types.js';
export const createTaskWorkflowFinishedSamplePayload = ({ data = {} } = {}) => {
    return {
        eventType: WEBHOOK_EVENT_TYPES.TASK_WORKFLOW_FINISHED,
        ...getUserAndEventTime(),
        data
    };
};
//# sourceMappingURL=task-workflow-finished.js.map